import { XsrfOptions } from 'src/app/common/interceptors/xsrf.interceptor';
import { LogLevel } from 'src/app/common/util/log';

export const basePath: string = 'https://internal.api.test.union-investment.de/web/ik/rpt/api/v1';
export const assetPath: string = 'https://widgetservice-test.fe.union-investment.de/export';

export const loglevel: LogLevel = LogLevel.TRACE;

export const manifestUrls = {
  doka: 'https://dokumentenablage-test.fe.union-investment.de/scs/iko-doka-dokumentenuebersicht/iko-doka-dokumentenuebersicht.manifest.json',
  fondstableSidepanel: {
    addSubscription: 'https://aboservice-test.fe.union-investment.de/abo-fixer-fonds-button.json',
    subscribedDocuments: 'https://aboservice-test.fe.union-investment.de/aboliste-spezifisch.json',
  },
};

export const authInterceptorIgnoredUrls: string[] = [
  manifestUrls.doka
];

export const xsrfInterceptorIgnoredUrls: string[] = [
  manifestUrls.doka
];

export const xsrfOptions: XsrfOptions = {
  cookieName: 'XSRF-TOKEN-FONDSUEBERSICHT',
  headerName: 'X-XSRF-TOKEN-FONDSUEBERSICHT',
};

export const apimApiVersion: string = '1.0.0';

export const logging = {
  connectionString:
    'InstrumentationKey=ff298b57-be59-42fb-890f-10e01c55790c;IngestionEndpoint=https://westeurope-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=26cc6f57-3568-4b72-882a-e545432e39c8',
};
